import axios from 'axios'
import { Point } from 'leaflet';

export class Hydranten{
    static async get(konvKey){
        try {
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/hydrant',
                { params: { konvKey: konvKey } }
            );

            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    static async add(x, y, durchlaufmenge, bemerkung, wasserquellenartID, feuerwehrID){
        console.log("Daten für neuen Hydranten:", { x, y, durchlaufmenge, bemerkung, wasserquellenartID, feuerwehrID });
        const hydrantData= {
            position: {x: x, y: y},
            durchlaufmenge: durchlaufmenge,
            bemerkung: bemerkung,
            wasserquellenartID: wasserquellenartID,
            feuerwehrID: feuerwehrID
        };

        try {
            const response = await axios.post(
                'https://feuerwehr-server.org:5000/addHydrant',
                hydrantData
            );
            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    static async delete(hydrantID, feuerwehrID){
        try {
            const response = await axios.delete(
                'https://feuerwehr-server.org:5000/deleteHydrant',
                { params: { wasserquellenID: hydrantID, feuerwehrID: feuerwehrID } }
            );
            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    static async update(hydrantID, x, y, durchlaufmenge, bemerkung, wasserquellenartID, feuerwehrID){
        const hydrantData = {
            wasserquellenID: hydrantID,
            bemerkung: bemerkung,
            durchlaufmenge: durchlaufmenge,
            feuerwehrID: feuerwehrID,
            wasserquellenartID: wasserquellenartID,
        };
        hydrantData.wasserquellenartID = parseInt(hydrantData.wasserquellenartID);
        hydrantData.durchlaufmenge = parseInt(hydrantData.durchlaufmenge);

        console.log(hydrantData);
        try {
            const response = await axios.put(
                'https://feuerwehr-server.org:5000/updateHydrant',
                hydrantData
            );
            console.log(response);
            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }
}
